export const getAccessToken = (getAccessTokenSilently: any) => {
  try {
    const token = getAccessTokenSilently();
    return token;
  } catch (err) {
    console.error(err);
  }
};
